import { UseQueryOptions } from '@tanstack/react-query';
import QueryKeys from '@/utils/QueryKeys';
import { plato_api_glossary_terms_path } from '@/modules/routes';
import { BaseGlossaryTerm, ExtraAttributes, GlossaryTermSchema } from '@/types/api/v2/GlossaryTermSchema';
import useApi from './useApi';

interface UseGlossaryTermParams<K extends (keyof BaseGlossaryTerm)[], E extends (keyof ExtraAttributes)[]> {
  extra_attributes?: E;
  only?: K;
  params?: object;
}

type UseGlossaryTermOptions<K extends (keyof BaseGlossaryTerm)[], E extends (keyof ExtraAttributes)[]> =
  UseGlossaryTermParams<K, E>
  & Omit<UseQueryOptions<GlossaryTermSchema<K[number], E[number]>[]>, 'queryFn' | 'queryKey'>;

export default function useGlossaryTerms<
  K extends(keyof BaseGlossaryTerm)[],
  E extends (keyof ExtraAttributes)[],
>({
  extra_attributes = ([] as any as E),
  only,
  params = {},
  ...queryOptions
}: UseGlossaryTermOptions<K, E>) {
  return useApi<GlossaryTermSchema<K[number], E[number]>[], BaseGlossaryTerm, K, ExtraAttributes, E>({
    endpoint: plato_api_glossary_terms_path({ extra_attributes, only }),
    extra_attributes,
    only,
    params,
    placeholderData: [],
    queryKey: [QueryKeys.GlossaryTerms, extra_attributes, only],
    ...queryOptions,
  });
}
